import { render, staticRenderFns } from "./TileMultipleChoiceFrequency.vue?vue&type=template&id=5faf9784&scoped=true&"
import script from "./TileMultipleChoiceFrequency.vue?vue&type=script&lang=ts&"
export * from "./TileMultipleChoiceFrequency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf9784",
  null
  
)

export default component.exports